import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

export const DISPOSITION_KEY = 'disposition';

export interface DispositionType {
  isDispositionOpen: boolean,
  dispositionData: DispositionData
}
interface DispositionData {
  [contactId: string]: {
    [skillName: string]: {
      [dispositionTitle: string]: {
        value: ''
      }
    }
  };
}

export const initialDispositionState: DispositionType = {
  isDispositionOpen: false,
  dispositionData: {}
};

export const dispositionInteractionSlice = createSlice({
  name: DISPOSITION_KEY,
  initialState: initialDispositionState,
  reducers: {
    toggleDispositionCard: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isDispositionOpen: action.payload
      };
    },
    setDispositionData: (state, action) => {
      return {
        ...state,
        dispositionData: {...state.dispositionData, ...action.payload}
      }
    },
    setDispositionResolution: (state, action) => {
      const {contactId, isResolved} = action.payload;
      return {
        ...state,
        dispositionData: {
          ...state.dispositionData, 
          [contactId]: {
            ...state.dispositionData[contactId],
            isResolved
          }
        },
        isDispositionOpen: isResolved
      }
    },
    clearDispositionById: (state, action) => {
      return {
        ...state,
        dispositionData: {
          ...state.dispositionData, 
          [action.payload]: undefined
        },
      }
    }
  }
});

export const dispostionInteractionReducer = dispositionInteractionSlice.reducer;

export const dispositionInteractionActions = dispositionInteractionSlice.actions;

/**
 * Function to get disposition type
 * @param rootState - DispositionType
 * @returns It returns disposition type
 * @example - const disposition = getDispositionState(rootState)
 */
export const getDispositionState = (rootState: {
  disposition: DispositionType;
}) => rootState[DISPOSITION_KEY];

export const getIsDispositionOpen = createSelector(
  getDispositionState,
  (state:DispositionType) => state.isDispositionOpen
);

export const getDispositionData = createSelector(
  getDispositionState,
  (state:DispositionType) => state.dispositionData
);
